import { Injectable } from '@angular/core';
import { Platform } from "@ionic/angular";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { AppAvailability } from '@ionic-native/app-availability/ngx';

@Injectable({ providedIn: 'root' })
export class ExternalLinkService {

  constructor(
    private platform: Platform,
    private iab: InAppBrowser,
    private appAvailability: AppAvailability
  ) {
  }

  launchExternalApp(iosSchemaName: string, androidPackageName: string, appUrl: string, httpUrl: string, username: string) {
    
    let app: string;
    
    if (this.platform.is('ios')) {
      app = iosSchemaName;
    } else if (this.platform.is('android')) {
      app = androidPackageName;
    } else {
      this.iab.create(httpUrl + username, '_system');
      return;
    }
  
    this.appAvailability.check(app).then(
      () => { // success callback
        this.iab.create(appUrl + username, '_system');
      },
      () => { // error callback
        console.log(username);
        this.iab.create(httpUrl + username);
      }
    );
  }
  
  openInstagram(username: string) {
    this.launchExternalApp('instagram://', 'com.instagram.android', 'instagram://user?username=', 'https://www.instagram.com/', username);
  }
}
